<template>
    <div id="master" ref="content"
        class="landing d-flex flex-wrap align-items-start align-content-start justify-content-start px-0 m-0">
        <menutop :menu="menu" />
        <div id="top" ref="top"></div>

        <template v-for="(element, index) in elements" :key="index">
            <component v-if="element.tagName.toLowerCase() != 'import-component'" :is="element.tagName.toLowerCase()"
                v-bind="extractAttributes(element)">
                <template v-for="(child, index) in element.childNodes">
                    <template v-if="child.nodeName == '#text'">
                        {{ child.textContent }}
                    </template>
                    <template v-else>
                        <DynamicComponent :content="child.outerHTML" :test="test" :con="con"
                            @updateAnimes="updateAnimateBlocks"></DynamicComponent>
                    </template>
                </template>
            </component>
            <template v-else>
                <DynamicComponent :content="element.outerHTML" :test="test" :con="con"
                    @updateAnimes="updateAnimateBlocks"></DynamicComponent>
            </template>
        </template>
        <Footer bg="black" class="section" />
    </div>
</template>

<script>
import Footer from '@/components/pages/FooterEfisenseLandings/FooterEfisenseLandings.vue'
import { useHead } from '@vueuse/head';
import menutop from '@/components/structure/menutop.vue'
import DynamicComponent from '@/components/structure/DynamicComponent.vue'

export default {
    props: {
        con: {
            default: {},
            type: Object
        },
        flinks: {
            default: {},
            type: Object
        },
    },
    data() {
        return {
            saveLandings: [],
            landingInfo: null,
            transiteShow: 0, //muestra transicion
            transiteHide: 0, //oculta transicion
            transiteType: 1, //type de transicion
            title: '',
            menu: 'white',
            rawContent: '',
            elements: [],
            observer: null,
            hidden: [],
            host: this.$route.name == 'landingTest' ? 'https://draft7.efisen.se/landings' : 'https://d1tlwjnil29m1k.cloudfront.net/efisense/landings',
            domain: this.$route.name == 'landingTest' ? 'https://draft7.efisen.se/landings/assets' : 'https://d1tlwjnil29m1k.cloudfront.net/efisense/landings/assets',
            test: this.$route.name == 'landingTest' ? true : false
        };
    },
    components: {
        DynamicComponent,
        menutop,
        Footer
    },
    async mounted() {
        await this.getLandings()
        // this.elements = []; 
        // const state = history.state;
        // // console.log('state:', state);
        // this.landingInfo = {
        //     idRecord: state.idRecord,
        //     name: state.name,
        //     description: state.description,
        //     url: state.url
        // }
        // // this.getLanding();
        // this.transiteShow++;
        // //this.loadScript();
        // this.getLanding();
        // this.$scrollInTop();
    },
    beforeUnmount() {
        this.elements = []
        try {
            this.removeScript();
            document.querySelectorAll('.landingDefine').forEach((tag) => {
                tag.remove();
            })
        } catch (err) { }
        if (this.observer) { this.observer.disconnect(); }
    },
    watch: {
        '$route.fullPath': {
            immediate: true,
            handler() {
                this.elements = [];
                this.loadLanding()
            }
        }
    },
    methods: {
        async loadLanding() {
            // await this.getLandings()
            this.elements = [];
            const state = history.state;
            // console.log('state:', state);
            if (state && state.idRecord) {
                this.landingInfo = {
                    idRecord: state.idRecord,
                    name: state.name,
                    description: state.description,
                    url: state.url
                }
            } else {
                this.saveLandings = []
                const landings = await this.getLandings()   // ahora SÍ espera a fetch
                const findLanding = this.saveLandings.find(x => {
                    return x.relativePath == this.$route.params.id
                });
                if (findLanding) {
                    this.landingInfo = {
                        idRecord: findLanding.idRecord,
                        name: findLanding.name,
                        description: findLanding.description,
                        url: findLanding.url
                    }
                } else {
                    this.$router.push({ 
                        path: '/',
                    })
                }
            }
            this.transiteShow++;
            await this.getLanding();
            await this.waitForContentReady();
            this.scrollToTop();
        },
        updateAnimateBlocks() {
            this.hidden = document.querySelectorAll(".animate");
            this.resetObserver();
            // Asegura scroll al terminar la animación de setup
            this.$nextTick(() => this.scrollToTop());
        },
        async waitForContentReady() {
            // 1) asegura render de Vue
            await this.$nextTick();

            const container = this.$refs.content || document.body;

            // 2) espera carga de imágenes/iframes pero con timeout corto
            await this._waitForMedia(container, 1500);

            // 3) espera que el layout se estabilice (sin cambios) por ~300ms o timeout total 4s
            await this._waitForStability(container, { stableMs: 300, timeoutMs: 4000 });

            // 4) dos rAF para garantizar layout final
            await new Promise(r => requestAnimationFrame(() => requestAnimationFrame(r)));
        },
        _waitForMedia(root, timeoutMs = 1500) {
            const promises = [];

            const imgs = Array.from(root.querySelectorAll('img'));
            for (const img of imgs) {
                if (img.complete) continue;
                promises.push(new Promise(res => {
                    const done = () => { img.removeEventListener('load', done); img.removeEventListener('error', done); res(); };
                    img.addEventListener('load', done, { once: true });
                    img.addEventListener('error', done, { once: true });
                }));
            }

            const iframes = Array.from(root.querySelectorAll('iframe'));
            for (const fr of iframes) {
                // algunos iframes nunca disparan eventos accesibles; usa un timeout
                promises.push(new Promise(res => setTimeout(res, 200)));
            }

            if (promises.length === 0) return Promise.resolve();
            return Promise.race([
                Promise.allSettled(promises),
                new Promise(res => setTimeout(res, timeoutMs)),
            ]);
        },
        _waitForStability(root, { stableMs = 300, timeoutMs = 4000 } = {}) {
            return new Promise(resolve => {
                let lastChange = performance.now();
                let finished = false;

                const end = () => {
                    if (finished) return;
                    finished = true;
                    ro.disconnect();
                    mo.disconnect();
                    clearInterval(checker);
                    resolve();
                };

                const markChange = () => { lastChange = performance.now(); };

                const ro = new ResizeObserver(markChange);
                const mo = new MutationObserver(markChange);

                ro.observe(root);
                mo.observe(root, { childList: true, subtree: true, attributes: true, characterData: true });

                const checker = setInterval(() => {
                    if (performance.now() - lastChange >= stableMs) end();
                }, 50);

                setTimeout(end, timeoutMs);
            });
        },
        scrollToTop() {
            const el = this.$refs.top;
            if (!el) return;
            // 'start' asegura que quede arriba del todo
            el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        },
        resetObserver() {
            if (this.observer) {
                this.hidden.forEach(entry => this.observer.unobserve(entry));
                this.observer.disconnect();
            }
            this.createObserver();
        },
        createObserver() {
            const options = {
                root: null,
                rootMargin: '0%',
                threshold: 0.3
            };
            this.observer = new IntersectionObserver(this.handleIntersect, options);
            this.hidden.forEach(entry => this.observer.observe(entry));
        },
        handleIntersect(entries) {
            entries.forEach(entry => {
                entry.target.classList.add('prepare-hidden');
                if (entry.isIntersecting) {
                    entry.target.classList.add('run');
                }
            });
        },
        updateMetaTags(title = false, description = false, url = false, image = false) {
            if (title) {
                useHead({
                    title,
                    meta: [
                        { property: 'og:title', content: title },
                    ],
                });
            }
            if (description) {
                useHead({
                    meta: [
                        { property: 'og:description', content: description },
                    ],
                });
            }
            if (url) {
                useHead({
                    meta: [
                        { property: 'og:url', content: url },
                    ],
                });
            }
            if (image) {
                useHead({
                    meta: [
                        { property: 'og:image', content: image },
                    ],
                });
            }
        },
        async getLandings() {
            try {
                const res = await fetch('https://dashboard.efisense.net/apiCRM/Landing/getList', { method: 'POST' })
                const data = await res.json()
                // valida estructura
                const landings = data.data
                landings.forEach(x => {
                    if (x.landings.length > 0) {
                        if (this.saveLandings.length > 0 ) {
                            this.saveLandings.push(...x.landings)
                        } else {
                            this.saveLandings = x.landings
                        }
                    }
                    if (x.subs.length > 0) {
                        x.subs.forEach(y => {
                            if (y.landings.length > 0) {
                                 if (this.saveLandings.length > 0 ) {
                                this.saveLandings.push(...y.landings)
                            } else {
                                this.saveLandings = y.landings
                            }
                            }
                        })
                    }
                })
                // this.saveLandings = []
                // this.saveLandings = landings
                return this.saveLandings             // ⬅️ IMPORTANTE: devolver algo
            } catch (e) {
                this.saveLandings = []
                throw e                               // o return []
            }
        },
        // getLandings() {
        //     const config = {
        //         method: 'POST',
        //         headers: {
        //             'Content-Type': 'application/json',
        //         }
        //     }
        //     fetch('https://noisy.efisense.xyz/apiCRM/Landing/getList', config)
        //         .then(response => response.json())
        //         .then(data => {
        //             // console.log('Landings fetched:', data)
        //             if (data.code && data.code === 200) {
        //                 const res = data.data
        //                 res.forEach(x => {
        //                     console.log('Landing:', x)
        //                     if (x.landings.length > 0) {
        //                         this.saveLandings.push(...x.landings)
        //                     }
        //                     if (x.subs.length > 0) {
        //                         x.subs.forEach(y => {
        //                             if (y.landings.length > 0) {
        //                                 this.saveLandings.push(...y.landings)
        //                             }
        //                         })
        //                     }
        //                 })
        //                 console.log('Landings processed:', this.saveLandings)
        //             } else {
        //                 this.saveLandings = []
        //                 console.error('Error fetching landings:', data.message)
        //             }
        //         })
        //         .catch(error => {
        //             console.error('Error fetching landings:', error)
        //         })
        // },
        loadScript() {
            const script = document.createElement('script');
            script.src = 'https://d1tlwjnil29m1k.cloudfront.net/onico/onicoSchedulerWidget.js';
            /*script.src = 'https://draft9.efisense.xyz/onicoSchedulerWidgetDevLocal.js';*/
            script.id = 'widget';
            document.head.appendChild(script);
        },
        removeScript() {
            const script = document.getElementById('widget');
            if (script) {
                document.head.removeChild(script);
            }
        },
        extractAttributes(element) {
            let attrs = {};
            Array.from(element.attributes).forEach(attr => {
                attrs[attr.name] = attr.value.includes('{{autodomainassets}}')
                    ? attr.value.replace(/{{autodomainassets}}/g, this.domain)
                    : attr.value;
            });
            // console.log("atributos: ", attrs);
            return attrs;
        },
        getLanding() {
            if (this.landingInfo && this.landingInfo.idRecord) {
                document.title = String(this.landingInfo.name)

                const config = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                }
                fetch(`https://dashboard.efisense.net/apiCRM/Landing/getLanding/${this.landingInfo.idRecord}`, config)
                    .then(response => response.json())
                    .then(data => {
                        // // console.log('Landings fetched:', data)
                        if (data.code && data.code === 200) {
                            this.rawContent = data.data.content;
                            this.rawContent = this.rawContent.replace(/{{autodomainassets}}/g, this.domain);
                            this.renderContent();
                            this.transiteHide++;
                            this.updateAnimateBlocks();
                            // this.$scrollInTop();
                        } else {
                            this.landings = []
                            // console.error('Error fetching landings:', data.message)
                        }
                    })
                    .catch(error => {
                        // console.error('Error fetching landings:', error)
                    })

                // this.con.getLandings([this.$route.params.id, this.test]).then((res) => {
                //     if (res.code == 200 && res.data != null && res.data != false && res.data != null) {
                //         if (res.data.exists) {
                //             this.rawContent = res.data.content;
                //             this.renderContent();
                //             this.transiteHide++;
                //             this.updateAnimateBlocks();
                //             return true;
                //         }
                //     }
                //     this.transiteHide++;
                //     this.$router.replace({ name: 'NotFound' })
                // }).catch((err) => { this.transiteHide++; this.$router.replace({ name: 'NotFound' }) })
            } else {
                this.transiteHide++;
                this.$router.push({
                    path: '/'
                })
            }
        },
        getStyle(element) {
            const styleObject = {};
            for (let i = 0; i < element.style.length; i++) {
                const styleName = element.style[i];
                styleObject[styleName] = element.style.getPropertyValue(styleName);
            }
            return styleObject;
        },
        getChildNodes(e) {
            // Verifica si parentElement está definido
            if (encodeURI) {
                // Devuelve los childNodes como un array
                return Array.from(e.childNodes);
            }
            return [];
        },
        setConfs(head) {
            Array.from(head.children).forEach(child => {
                switch (child.tagName.toLowerCase()) {
                    // case 'title':
                    //     let titled = String(child.textContent).replace(/[^a-z0-9 áéíóúüñÁÉÍÓÚÜÑ]+/gi, "");
                    //     document.title = titled;
                    //     this.updateMetaTags(titled, false, 'https://draft7.efisen.se/'+(this.test ? 't/' : 'l/')+this.$route.params.id)
                    //     break;
                    case 'menu':
                        this.menu = String(child.textContent).replace(/[^a-z0-9 áéíóúüñÁÉÍÓÚÜÑ]+/gi, "");
                        break;
                    case 'description':
                        this.updateMetaTags(false, String(child.textContent).replace(/[^a-z0-9 áéíóúüñÁÉÍÓÚÜÑ]+/gi, ""), false)
                        break;
                    case 'cardimage':
                        this.updateMetaTags(false, false, false, child.textContent.replace(/{{autodomainassets}}/g, this.domain))
                        break;
                    case 'style':
                        const styleTag = document.createElement('style');
                        styleTag.classList.add('landingDefine');
                        styleTag.textContent = String(child.textContent);
                        document.head.appendChild(styleTag);
                        break;
                    case 'meta':
                        const metaTag = document.createElement('meta');
                        Array.from(child.attributes).forEach(attr => {
                            metaTag.setAttribute(attr.name, attr.value);
                        });
                        document.head.appendChild(metaTag);
                        break;
                    case 'script':
                        const scriptElement = document.createElement('script');
                        scriptElement.textContent = String(child.textContent);
                        scriptElement.classList.add('landingDefine');
                        document.head.appendChild(scriptElement);
                        break;
                    default:
                        break;
                }
            });
        },
        async renderContent() {
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(this.rawContent, "text/html");

            const landingHead = xmlDoc.getElementsByTagName("landing-head")[0];
            const landingBody = xmlDoc.getElementsByTagName("landing-body")[0];


            if (landingHead && landingBody) {

                this.setConfs(landingHead);

                const childElements = Array.from(landingBody.children);
                this.elements = childElements
                await this.$nextTick()
                // childElements.forEach(element => {
                //     this.elements.push(element);
                // });

            } else {
                // console.error("Los elementos landing-head y landing-body deben estar en la landing.");
                this.$router.replace({ name: 'NotFound' })
            }
        },
    },
};
</script>

<style scoped>
.landing {
    overflow-x: hidden;
}

#master {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    justify-content: flex-start;
    height: 100vh;
    width: 100vw;
    overflow-x: hidden;
}
</style>